export function addUndisplayCountToIndex(columns, index) {
  let numHiddenBeforeIndex = 0;

  for (let i = 0; i < index; i++) {
    if (columns[i].displayType === 'NONE') {
      numHiddenBeforeIndex += 1;
    }
  }
  return index + numHiddenBeforeIndex;
}

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list).filter((column) => column.displayType !== 'NONE' && column.displayType !== 'EXPORT_ONLY');
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

export function sortColumnsByInt(columns = [], propName) {
  return columns.sort((filterA, filterB) => {
    const nameA = filterA[propName];
    const nameB = filterB[propName];
    return nameA - nameB;
  });
}

export function getAvailableDataColumns(columns) {
  const dataColumns = columns.filter((column) => column.isSummaryColumn !== true);
  const sortedColumns = sortColumnsByInt(dataColumns, 'displayOrder');
  return sortedColumns;
}

export function getActiveColumns(columns) {
  const dataColumns = columns.filter((column) => column.isSummaryColumn !== true);
  const sortedColumns = sortColumnsByInt(dataColumns, 'displayOrder');
  return sortedColumns;
}

export function enableAddAllColumnsAction(columns) {
  return columns.length > 0;
}

export function enableRemoveAllColumnsAction(columns) {
  return columns.length !== 0;// columns.filter((column) => !column.isRequired && column.displayType !== 'NONE').length > 0;
}

export function enableShowAllColumnsAction(columns) {
  return columns.filter((column) => column.isHidden && column.displayType !== 'NONE').length > 0;
}

export function enableHideAllColumnsAction(columns) {
  return columns.filter((column) => !column.isHidden && column.displayType !== 'NONE').length > 0;
}

export function formatSavedColumns(columns) {
  return columns
    .map((column) => {
      return {
        ...column,
        displayOrder: column.displayOrder,
        visible: !column.isHidden,
        identifier: column.identifier,
        name: column.name,
        defaultIsVisible: column.isSelected,
      };
    });
}

export default {
  addUndisplayCountToIndex,
  reorder,
  sortColumnsByInt,
  getActiveColumns,
  getAvailableDataColumns,
  enableAddAllColumnsAction,
  enableRemoveAllColumnsAction,
  enableShowAllColumnsAction,
  enableHideAllColumnsAction,
  formatSavedColumns,
};
